import React from 'react';
import { Upload, CheckCircle, MessageCircle, Play } from 'lucide-react';

interface WelcomeScreenProps {
  name: string;
  progress: number;
  onStartInterview: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  name,
  progress,
  onStartInterview
}) => {
  return (
    <div className="bg-gradient-to-br from-purple-50 via-white to-pink-50 welcome-screen">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-10 text-center mx-auto max-w-8xl">
        <div className="mb-10">
          <div
            style={{ background: "linear-gradient(135deg, #bb1ccc 0%, #d946ef 100%)" }}
            className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg"
          >
            <MessageCircle className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-6">
            Welcome {name}!
          </h1>
          <p className="text-gray-600 text-xl mb-2 leading-relaxed">
            Let's begin your comprehensive knowledge transfer interview session
          </p>
          <p className="text-gray-600 text-xl mb-10 leading-relaxed">
            You can do following 3 activities during the interview
          </p>
        </div>

        {/* Feature Icons */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="flex flex-col items-center p-6 bg-blue-50 rounded-xl border border-blue-200 transform hover:scale-105 transition-all duration-200">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-4 shadow-md">
              <Upload className="w-8 h-8 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-3 text-lg">
              Upload Documents
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Upload any new documents that come up during discussion
            </p>
          </div>

          <div className="flex flex-col items-center p-6 bg-green-50 rounded-xl border border-green-200 transform hover:scale-105 transition-all duration-200">
            <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center mb-4 shadow-md">
              <CheckCircle className="w-8 h-8 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-3 text-lg">
              Validate AI Summary
            </h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Review and validate AI-generated summaries
            </p>
          </div>

          <div className="flex flex-col items-center p-6 bg-purple-50 rounded-xl border border-purple-200 transform hover:scale-105 transition-all duration-200">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl flex items-center justify-center mb-4 shadow-md">
              <MessageCircle className="w-8 h-8 text-white" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-3 text-lg">Live Chat</h3>
            <p className="text-gray-600 text-center leading-relaxed">
              Interactive conversation with AI assistant
            </p>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mb-7">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-gray-700">
              Progress
            </span>
            <span className="text-sm font-semibold text-gray-700">
              {progress}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 shadow-inner">
            <div
              className="h-3 rounded-full transition-all duration-500 shadow-sm"
              style={{ 
                width: `${progress}%`, 
                background: "linear-gradient(90deg, #bb1ccc 0%, #d946ef 100%)" 
              }}
            ></div>
          </div>
        </div>

        <button
          onClick={onStartInterview}
          style={{ background: "linear-gradient(135deg, #bb1ccc 0%, #d946ef 100%)" }}
          className="inline-flex items-center gap-3 text-white px-10 py-3 rounded-xl font-semibold hover:opacity-90 transition-all duration-200 shadow-lg text-xl transform hover:scale-105"
        >
          <Play className="w-6 h-6" />
          Start Interview Session
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;